import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import emergency from "../assets/img/HomePage/emergency.svg";
import referral from "../assets/img/HomePage/referral.svg";
import guidance from "../assets/img/HomePage/guidance.svg";
import laws from "../assets/img/HomePage/laws.svg";
import Footer from "../components/Footer";
import ModalAbout from "../components/ModalAbout";
import { makeStyles } from "@mui/styles";
import Options from "../components/Options";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getTitleFromAppContent, getContentTitle } from "../helpers/utils";

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.primary.main,
  },
  sectionBgLight: {
    backgroundColor: "#F6F1F4",
  },
  emergencyBg: {
    backgroundColor: theme.palette.emergency.light,
  },
  emergencyTextBg: {
    backgroundColor: theme.palette.emergency.main,
  },
  referralBg: {
    backgroundColor: theme.palette.referral.light,
  },
  referralTextBg: {
    backgroundColor: theme.palette.referral.main,
  },
  guidanceBg: {
    backgroundColor: theme.palette.guidance.light,
  },
  guidanceTextBg: {
    backgroundColor: theme.palette.guidance.main,
  },
  lawsBg: {
    backgroundColor: theme.palette.laws.light,
  },
  lawsTextBg: {
    backgroundColor: theme.palette.laws.main,
  },
}));

const tileClass =
  "flex flex-col cursor-pointer rounded-xl min-h-[10rem] w-full touch-manipulation";

const HumQadamHome = () => {
  const classes = useStyles();
  const { appContent } = useSelector((state) => state.appContent);
  const [openAbout, setOpenAbout] = useState(false);
  const [emergencyTitle, setEmergencyTitle] = useState("");
  const [referralTitle, setReferralTitle] = useState("");
  const [guidanceTitle, setGuidanceTitle] = useState("");
  const [lawsTitle, setLawsTitle] = useState("");
  const handleOpen = () => setOpenAbout(true);
  const handleClose = () => {
    setOpenAbout(false);
  };

  useEffect(() => {
    if (appContent && appContent.length > 0) {
      setEmergencyTitle(getTitleFromAppContent(appContent, "Emergency Services"));
      setReferralTitle(
        getContentTitle(appContent, [
          "Support Providing Organizations",
          "Referral",
          "Referral Guide",
        ])
      );
      setGuidanceTitle(getTitleFromAppContent(appContent, "Step by Step Guidance"));
      setLawsTitle(getTitleFromAppContent(appContent, "Relevant Laws"));
    }
  }, [appContent]);

  return (
    <div
      className={`${classes.sectionBgLight} min-h-[100dvh] w-full flex flex-col justify-between`}
    >
      <div className="w-full">
        <Header />
        <Options handleOpen={handleOpen} />
        <div className="px-5 pb-16 hq-safe-bottom w-full">
          <div className="grid grid-cols-2 gap-3 w-full max-w-2xl mx-auto">
            <Link
              to={"/emergency-services"}
              className={`${tileClass} ${classes.emergencyBg}`}
            >
              <div className="flex-1 flex items-center justify-center py-4">
                <img
                  src={emergency}
                  alt=""
                  className="h-20 w-auto max-w-[80%] object-contain"
                />
              </div>
              <p
                className={`${classes.emergencyTextBg} text-center rounded-b-xl p-2 text-xs text-white`}
              >
                {emergencyTitle || "Emergency Services"}
              </p>
            </Link>
            <div className={`${tileClass} ${classes.referralBg}`}>
              <div className="flex-1 flex items-center justify-center py-4">
                <img
                  src={referral}
                  alt=""
                  className="h-20 w-auto max-w-[80%] object-contain"
                />
              </div>
              <p
                className={`${classes.referralTextBg} text-center rounded-b-xl p-2 text-xs text-white`}
              >
                {referralTitle || "Support Providing Organizations"}
              </p>
            </div>
            <div className={`${tileClass} ${classes.guidanceBg}`}>
              <div className="flex-1 flex items-center justify-center py-4">
                <img
                  src={guidance}
                  alt=""
                  className="h-20 w-auto max-w-[80%] object-contain"
                />
              </div>
              <p
                className={`${classes.guidanceTextBg} text-center rounded-b-xl py-2 text-xs text-white`}
              >
                {guidanceTitle || "Step by Step Guidance"}
              </p>
            </div>
            <div className={`${tileClass} ${classes.lawsBg}`}>
              <div className="flex-1 flex items-center justify-center py-4">
                <img
                  src={laws}
                  alt=""
                  className="h-20 w-auto max-w-[80%] object-contain"
                />
              </div>
              <p
                className={`${classes.lawsTextBg} text-center rounded-b-xl p-2 text-xs text-white`}
              >
                {lawsTitle || "Relevant Laws"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
        <ModalAbout open={openAbout} handleClose={handleClose} />
      </div>
    </div>
  );
};

export default HumQadamHome;
